export const EMAIL_REGEX_VALIDATOR =
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;

// With capture groups
export const PHONE_NUMBER_REGEX_VALIDATOR =
  /^(?:\+(1)\s?)?(?:\(([0-9]{3})\)|([0-9]{3}))-?\s?([0-9]{3})\s?-?\s?([0-9]{4})$/i;
